/**
 * Number Field Type - Common
 *
 * Field-type configuration shared by the inline (inline/number.tsx) and
 * modal (modal/number.tsx) renderers.
 */

import type { FieldTypeConfig } from '../../components/types';
import { S } from './columnWidths';

// ============================================================================
// Field Type Configuration
// ============================================================================

/**
 * Number field type configuration
 */
export const numberFieldType: FieldTypeConfig = {
  placeholder: (label: string) => `Enter ${label.toLowerCase()}...`,
  ...S,
};
